
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Separator } from "@/components/ui/separator";
import { AIAssistantPreferences } from "./ai/AIAssistantPreferences";
import { AgentConfiguration } from "./ai/AgentConfiguration";
import { useAIAssistantSettings } from "@/hooks/settings/useAIAssistantSettings";

export const AIAssistantSettings = () => {
  const { settings, isLoading, saveSettings } = useAIAssistantSettings();

  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="flex justify-center items-center h-40">
            <p className="text-muted-foreground">Loading settings...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="space-y-6 p-6">
        <div className="space-y-2">
          <h2 className="text-lg font-medium">AI Executive Assistant</h2>
          <p className="text-sm text-muted-foreground">
            Configure your AI assistant to help with emails, scheduling, and task management
          </p>
        </div>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label>Enable AI Executive Assistant</Label>
              <p className="text-sm text-muted-foreground">
                Let the AI assistant help manage your workflow
              </p>
            </div>
            <Switch
              checked={settings.enabled}
              onCheckedChange={(enabled) => saveSettings({ ...settings, enabled })}
            />
          </div>
          
          {settings.enabled && (
            <div className="space-y-4 mt-4">
              <AIAssistantPreferences />
              
              <Separator />
              
              <AgentConfiguration
                a2aEnabled={settings.a2aEnabled}
                multiAgentEnabled={settings.multiAgentEnabled}
                onA2AChange={(a2aEnabled) => saveSettings({ ...settings, a2aEnabled })}
                onMultiAgentChange={(multiAgentEnabled) => 
                  saveSettings({ ...settings, multiAgentEnabled })
                }
              />
              
              <Button 
                onClick={() => saveSettings(settings)}
                className="w-full"
              >
                Save AI Assistant Settings
              </Button>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
